const variables = {
	colors: {
		primary: '#262626',
		secondary: '#000',
		lightPrimary: '#A6A6A6'
	}
};

export default variables;
